module.exports = __webpack_public_path__ + "static/media/add driver.49c38be2.svg";